import { useInsuranceHikiukeDetail } from '../../hooks/features/insuranceHikiukeDetail';
import {
  LoadingSpinner,
  ErrorPage,
  Toolbar,
  PdfViewer,
} from '../../components/features/insuranceHikiukeDetail';
import FeedbackPopup from '../../components/popups/FeedbackPopup';
import BadReasonFeedbackPopup from '../../components/popups/BadReasonFeedbackPopup';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import '../../styles/InsuranceHikiukeDetail.css';

/**
 * 引受目安詳細ページコンポーネント
 * ViewとContainerを統合し、分割されたコンポーネントを組み合わせて表示
 */
const InsuranceHikiukeDetail = () => {
  const vm = useInsuranceHikiukeDetail();

  const {
    loading,
    showErrorPage,
    errorMessage,
    documentInfo,
    isMobile,
    isDocInfoAccordionOpen,
    zoomLevel,
    currentPage,
    totalPages,
    isRendering,
    isLandscape,
    pdfFile,
    pdfOptions,
    currentPopup,
    isFeedbackSubmitting,
    activeJumpButton,
    canJumpDisease,
    canJumpContents,
    canJumpLegend,
    canJumpAppendix,
    highlightsPolygon,
    highlightCanvasRef,
    pdfContainerRef,
    handleZoomIn,
    handleZoomOut,
    handlePrevPage,
    handleNextPage,
    handleChangePageInput,
    handlePageInputBlur,
    handleRetry,
    handleBackToSearch,
    toggleDocInfoAccordion,
    handleClose,
    handleFeedbackClose,
    handleGoodFeedback,
    handleBadFeedback,
    handleFeedbackSubmit,
    handleFeedbackBack,
    handleJumpDisease,
    handleJumpContents,
    handleJumpLegends,
    handleJumpAppendix,
    onDocumentLoadSuccess,
    onDocumentLoadError,
    onPageLoadSuccess,
    onPageLoadError,
    searchText,
    setSearchText,
    searchResults,
    currentSearchIndex,
    isSearching,
    isSearchOpen,
    setIsSearchOpen,
    handleSearch,
    handleNextSearchResult,
    handlePrevSearchResult,
    handleClearSearch,
    customTextRenderer,
    onGetTextSuccess,
    onTextLayerRenderSuccess,
    pdfDocument,
  } = vm;

  // ローディング表示
  if (loading) {
    return (
      <div
        className="insurance-detail-page hikiuke-meyasu-detail-page"
        style={{ overflow: 'hidden', height: '100vh', position: 'relative' }}
      >
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div
      className="insurance-detail-page hikiuke-meyasu-detail-page"
      style={{ overflow: 'hidden', height: '100vh', position: 'relative' }}
    >
      <div
        className={`detail-container ${isLandscape ? 'landscape-layout' : 'portrait-layout'}`}
        style={{ overflow: 'hidden', height: '100%' }}
      >
        <div className="pdf-viewer-container" style={{ overflow: 'hidden', height: '100%' }}>
          {showErrorPage ? (
            <ErrorPage
              errorMessage={errorMessage}
              onRetry={handleRetry}
              onBackToSearch={handleBackToSearch}
            />
          ) : (
            <>
              {/* ツールバー（モバイル検索アコーディオンを含む） */}
              <Toolbar
                documentInfo={documentInfo}
                isMobile={isMobile}
                isDocInfoAccordionOpen={isDocInfoAccordionOpen}
                onToggleDocInfoAccordion={toggleDocInfoAccordion}
                activeJumpButton={activeJumpButton}
                canJumpDisease={canJumpDisease}
                canJumpContents={canJumpContents}
                canJumpLegend={canJumpLegend}
                canJumpAppendix={canJumpAppendix}
                onJumpCurrentDisease={handleJumpDisease}
                onJumpContents={handleJumpContents}
                onJumpLegend={handleJumpLegends}
                onJumpAppendix={handleJumpAppendix}
                zoomLevel={zoomLevel}
                onZoomIn={handleZoomIn}
                onZoomOut={handleZoomOut}
                currentPage={currentPage}
                totalPages={totalPages}
                isRendering={isRendering}
                onPrevPage={handlePrevPage}
                onNextPage={handleNextPage}
                onChangePageInput={handleChangePageInput}
                onPageInputBlur={handlePageInputBlur}
                searchText={searchText}
                onSearchTextChange={setSearchText}
                searchResults={searchResults}
                currentSearchIndex={currentSearchIndex}
                isSearching={isSearching}
                isSearchOpen={isSearchOpen}
                onToggleSearchOpen={() => setIsSearchOpen(prev => !prev)}
                onSearch={handleSearch}
                onNextSearchResult={handleNextSearchResult}
                onPrevSearchResult={handlePrevSearchResult}
                onClearSearch={handleClearSearch}
                pdfDocument={pdfDocument}
                onClose={handleClose}
              />

              {/* PDFビューワー */}
              <PdfViewer
                ref={pdfContainerRef}
                pdfFile={pdfFile}
                pdfOptions={pdfOptions}
                currentPage={currentPage}
                zoomLevel={zoomLevel}
                isRendering={isRendering}
                highlightsPolygon={highlightsPolygon}
                highlightCanvasRef={highlightCanvasRef}
                onDocumentLoadSuccess={onDocumentLoadSuccess}
                onDocumentLoadError={onDocumentLoadError}
                onPageLoadSuccess={onPageLoadSuccess}
                onPageLoadError={onPageLoadError}
                customTextRenderer={customTextRenderer}
                onGetTextSuccess={onGetTextSuccess}
                onRenderTextLayerSuccess={onTextLayerRenderSuccess}
              />

              {/* 注意書き */}
              <div>
                ※ 正確な取扱いや判断については、各保険会社へご確認ください。
              </div>
              <div>
                ※ 本ページ以外にも関連内容が記載されている可能性があります。必要に応じて前後ページもご参照ください。
              </div>
            </>
          )}
        </div>
      </div>

      {/* フィードバックポップアップ */}
      {currentPopup === 'feedback' && (
        <FeedbackPopup
          onClose={handleFeedbackClose}
          handleGoodSubmit={handleGoodFeedback}
          handleBadSubmit={handleBadFeedback}
          isSubmitting={isFeedbackSubmitting}
        />
      )}

      {currentPopup === 'badReason' && (
        <BadReasonFeedbackPopup
          onClose={handleFeedbackClose}
          onBack={handleFeedbackBack}
          handleSubmit={handleFeedbackSubmit}
          isSubmitting={isFeedbackSubmitting}
        />
      )}
    </div>
  );
};

export default InsuranceHikiukeDetail;
